import getTokenBearer from '@/hooks/getTokenBearer';
import axios from 'axios';
import Cookies from 'js-cookie';

const baseURL = import.meta.env.VITE_API_URL;

export default function request(options) {
  // Create a fresh instance for each request
  const client = axios.create({ baseURL });

  // Get current token
  const token = Cookies.get('bdKey') || localStorage.getItem('bdKey');

  // Set authorization header if needed
  if (options.isAuth) {
    options.headers = {
      ...options.headers,
      Authorization: `${getTokenBearer()} ${token}`
    };
  }

  if (!options.headers || !Object.keys(options.headers).length) delete options.headers
  if ("isAuth" in options) delete options.isAuth

  const onSuccess = (response) => response;
  const onError = (error) => error;

  return client(options).then(onSuccess).catch(onError);
}
